/**!
 * Apricot
 * @version 4.4.0
 * @author Mitra Assadi, Scott Petts, Sarah Allison
 * @license
 * Copyright (c) 2021 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';

window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.version = '4.4.0';

// javaScript
export default {};
